import type { ReactNode } from 'react';

import { cx } from '../utils/cx';

export type BadgeTone = 'neutral' | 'good' | 'warn' | 'critical' | 'info' | 'accent';

export interface BadgeProps {
  readonly tone?: BadgeTone;
  readonly children: ReactNode;
}

/**
 * The prototypes' `.status-pill` — order status, delivery status, plan
 * badges, integration health. `tone` maps 1:1 onto the semantic token pairs
 * in tokens.css (good/warn/critical/info/accent), so a component never
 * reaches for a raw color: the mapping from business meaning to color is
 * made exactly once, here.
 */
export function Badge({ tone = 'neutral', children }: BadgeProps): ReactNode {
  return <span className={cx('ecom-badge', `ecom-badge--${tone}`)}>{children}</span>;
}

/** Semantic alias: identical rendering, named for where the spec calls it a status pill (DEV §7, §10.1). */
export const StatusPill = Badge;
